export const ORG_ID = process.env.REACT_APP_ORG_ID;
export const HOST = process.env.REACT_APP_HOST;
// export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '206940969308-mcjl5rg06rg84jf3d7ehlg14ijiqt9gj.apps.googleusercontent.com';
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '1052173053635-nl0mlebt1q6tjbkvom6q3qfm17pa2c2u.apps.googleusercontent.com';
export const BASE_API_URL = `${HOST}/${(ORG_ID ? `org/${ORG_ID}/` : '')}`;
window.ENV = process.env;
